import AssetSidebarView from './AssetSidebarView';
import useAssetSidebarData from './useAssetSidebarData';

type AssetSidebarProps = {
  id: string;
  onClose: () => void;
  onViewDetail?: () => void;
};

const AssetSidebar = ({ id, onClose, onViewDetail }: AssetSidebarProps) => {
  const {
    asset,
    workOrders,
    loading,
    error,
    loadingRename,
    loadingApprove,
    attributeLoading,
    renameAsset,
    approveAllChanges,
    onAttributesPendingChange,
    onAttributesSave,
  } = useAssetSidebarData(id);

  return (
    <AssetSidebarView
      asset={asset}
      workOrders={workOrders}
      loading={loading}
      error={error}
      loadingRename={loadingRename}
      loadingApprove={loadingApprove}
      attributeLoading={attributeLoading}
      onClose={onClose}
      onViewDetail={onViewDetail}
      onRename={renameAsset}
      onApproveAllChanges={approveAllChanges}
      onAttributesPendingChange={onAttributesPendingChange}
      onAttributesSave={onAttributesSave}
    />
  );
};

export default AssetSidebar;
